export default __webpack_public_path__ + "static/media/chat-balloon.9352cf65.svg";